import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import { QUERY_KEYS, notificationTypes } from "library/shared";
import api from "service/api";
import { errorHandler } from "components/AppHeader/NotificationMessages";
import { IVehicle } from "library/types";

const loadCopyOfferData = async (offerId: string) => {
  const response = await api.post(`/GetCopyOfOfferData`, {
    appInfo: {
      dataObj: {
        offerId,
      },
      resolvedProperties: {
        title: "BCR Heavy Machinery",
      },
    },
  });

  return response.data?.appInfo;
};

export function useLoadCopyOfferData(
  offerId,
  isCopyOffer
): UseQueryResult<IVehicle> {
  return useQuery<IVehicle, Error>(
    [QUERY_KEYS.offerDataItem, offerId, isCopyOffer],
    () => loadCopyOfferData(offerId),
    {
      enabled: !!isCopyOffer,
      onError: (error: any) => {
        errorHandler({
          label: "Error",
          type: notificationTypes.error,
          value: "Error while loading copy offer item data",
          errors: error?.message,
          fieldName: "",
        });
      },
      staleTime: 1000,
    }
  );
}

export const useInvalidateCopyOfferData = () => {
  const queryClient = useQueryClient();

  queryClient.invalidateQueries({ queryKey: QUERY_KEYS.offerCopyDataItem });
};
